import { baseStyles, buttonStyles, formStyles } from '@/styles';
import { localized, t } from '@weavedev/lit-i18next';
import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('fg-autocomplete')
@localized()
export class FgAutocomplete extends LitElement {
  @property({ type: Array })
  items: string[] = [];

  @property({ type: String })
  placeholder = '';

  @property({ type: Boolean })
  resetValues = false;

  @property({ type: Boolean })
  translatable = false;

  render() {
    return html`
      <input
        list="autocomplete-items"
        class="autocomplete-input"
        type="text"
        placeholder=${this.placeholder}
        required
        onfocus="${this.resetValues ? "this.value=''" : ''}"
        onchange="${this.resetValues ? 'this.blur();' : ''}"
      />
      <datalist id="autocomplete-items">
        ${this.items.map(item => {
          let value = item;
          if (this.translatable) {
            value = t(item);
          }
          return html`
            <option value=${value}></option>
          `;
        })}
      </datalist>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    formStyles,
    css`
      .auto-complete-wrapper {
        position: relative;
        width: auto;
      }

      input {
        width: 100%;
      }

      input[list]::-webkit-calendar-picker-indicator,
      input[list]::-webkit-list-button {
        opacity: 0 !important;
      }
    `,
  ];
}
